import React from 'react';
import { Study, StudyStatusType } from '@faro/study-designer-model';

/**
 * Represents study related contextual information needed for proper data loading
 */
export interface StudyContextValue {
    /**
     * ID of the active study
     */
    studyId: string;
    /**
     * ID of the active study's main variant
     */
    mainVariantId: string;
    /**
     * The current status type of the study
     */
    statusType: StudyStatusType;

    name: Pick<Study, 'name'>;

    /**
     * Indicates if the study is a master study
     */
    isMasterStudy: boolean;
}

export const StudyContext = React.createContext({} as StudyContextValue);

export const useStudyContext = (): StudyContextValue => {
    return React.useContext(StudyContext);
};
